document.addEventListener('click', event => {
  const link = event.target.closest('[data-warra-pack-link]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const product = link.closest('product-info');
  if (!product) return;
  const sizes = [...product.querySelectorAll('variant-selects input:checked, variant-selects select')].map(input => input.value).filter(value => /^\d+[-–]\d+$/.test(value));
  const variants = JSON.parse(link.querySelector('[data-warra-pack-variants]')?.textContent || '[]');
  const matching = variants.find(variant => {
    const target = variant.options.filter(value => /^\d+[-–]\d+$/.test(value));
    return sizes.slice(0, target.length).every((size, index) => target[index] === size) && variant.available;
  });
  if (matching) {
    const url = new URL(link.href);
    url.searchParams.set('variant', matching.id);
    link.href = url.href;
  }
});
const fitStory = scope => {
  scope.querySelectorAll('[data-warra-story-slider]').forEach(component => {
    if (component.dataset.warraFit) return;
    component.dataset.warraFit = 'true';
    const slider = component.querySelector('.slideshow');
    const slides = [...slider.querySelectorAll('.slideshow__slide')];
    const fit = () => {
      const index = Math.max(0, Math.round(slider.scrollLeft / Math.max(slides[0]?.offsetWidth || 1, 1)));
      const active = slides[index];
      if (active) slider.style.height = active.getBoundingClientRect().height + 'px';
    };
    component.addEventListener('slideChanged', fit);
    slider.addEventListener('scroll', fit, {passive:true});
    const observer = new ResizeObserver(fit);
    slides.forEach(slide => observer.observe(slide));
    fit();
  });
};
fitStory(document);
document.addEventListener('shopify:section:load', event => fitStory(event.target));
